import { render, staticRenderFns } from "./valueSystem.vue?vue&type=template&id=1242850f&scoped=true"
import script from "./valueSystem.vue?vue&type=script&lang=js"
export * from "./valueSystem.vue?vue&type=script&lang=js"
import style0 from "./valueSystem.vue?vue&type=style&index=0&id=1242850f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1242850f",
  null
  
)

export default component.exports